import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineEpromConfigurationLabel";

const url = "/api/machines/MachineEpromConfigurationLabel";

export const machineEpromConfigurationLabel = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "EPROM Label",
    url,
  },
);
